// extracted by mini-css-extract-plugin
export default {"home":"home_home__nCus0","icon":"home_icon__9Qo4h","logo":"home_logo__EcbVi"};